import borders from "../base/borders";
import colors from "../base/colors";

const { borderRadius } = borders;
const { white, slate_gray, navy, gold } = colors;

export default {
    styleOverrides: {
      root: {
        backgroundColor: slate_gray.main,
    },
  },
  variants: [
    {
      props: { variant: 'slate' },
      style: {
        backgroundColor: slate_gray.main,
      },
    },
    {
      props: { variant: 'navy' },
      style: {
        backgroundColor: navy.main,
      },
    },
    {
      props: { variant: 'gold' },
      style: {
        backgroundColor: gold.main,
      },
    },
    {
      props: { variant: 'contained' },
      style: {
        backgroundColor: slate_gray.main,
        boxShadow: "0 0 2rem 0 rgba(0, 0, 0, 0.15)",
      },
    },
    {
      props: { variant: 'outlined' },
      style: {
        border: `1px solid ${white.main}`,
      },
    },
    {
      props: { variant: 'elevation' },
      style: {
        boxShadow: "0 0 2rem 0 rgba(0, 0, 0, 0.15)",
      },
    },
  ],
};
